import {ArtisticObject, ArtisticObjectListing, UpdateArtisticObject} from '../types/ArtisticObject';
import {DateRangeValidationRequest, DateRangeValidationResponse, EMPTY_RANGES} from '../types/Ranges';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class ArtisticObjectsService {
  public async getAllArtisticObjects(): Promise<ArtisticObjectListing[]> {
    return handleError(
      () => httpClient.get<ArtisticObjectListing[]>('/artistic-objects'),
      'Error fetching artistic objects:',
      () => []
    );
  }

  public async getArtisticObject(id: string): Promise<ArtisticObject> {
    return handleError(
      () => httpClient.get<ArtisticObject>(`/artistic-objects/${id}`),
      'Error fetching artistic object:'
    );
  }

  public async createArtisticObject(object: Omit<UpdateArtisticObject, 'id'>): Promise<void> {
    const objectWithId = {
      ...object,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/artistic-objects', objectWithId),
      'Error creating artistic object:'
    );
  }

  public async updateArtisticObject(object: UpdateArtisticObject): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/artistic-objects/${object.id}`, object),
      'Error updating artistic object:'
    );
  }

  public async deleteArtisticObject(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/artistic-objects/${id}`),
      'Error deleting artistic object:'
    );
  }

  public async validateDateRange(dateSpecification: string): Promise<DateRangeValidationResponse> {
    const request: DateRangeValidationRequest = { specification: dateSpecification };
    return handleError(
      () => httpClient.post<DateRangeValidationResponse>('/artistic-objects/range/validate', request),
      'Error validating date range:',
      () => ({ valid: false, ranges: EMPTY_RANGES })
    );
  }
}

const artisticObjectsService = new ArtisticObjectsService();
export default artisticObjectsService;
